var _rect, _path, _path2, _g, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedalBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 10,
    fill: "#F6F7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6085 1L19.9729 20.3225H25.9177L33.9973 1H27.6085Z",
    fill: "#6359CF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_246_6452",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 19,
    width: 21,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2788 19.124H32.6477V42.1223H12.2788V19.124Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_246_6452)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5053 22.4933V20.8112C18.5053 20.5377 18.7273 20.3149 19.0001 20.3149H25.9264C26.1992 20.3149 26.4212 20.5377 26.4212 20.8112V22.4933C25.2045 21.9781 23.867 21.6932 22.4632 21.6932C21.0595 21.6932 19.722 21.9781 18.5053 22.4933ZM27.6087 23.0908V20.8112C27.6087 19.8808 26.854 19.124 25.9264 19.124H19.0001C18.0725 19.124 17.3179 19.8808 17.3179 20.8112V23.0908C14.3031 24.8644 12.2788 28.149 12.2788 31.9078C12.2788 37.5491 16.8384 42.1223 22.4633 42.1223C28.0879 42.1223 32.6477 37.5491 32.6477 31.9078C32.6477 28.149 30.6235 24.8644 27.6087 23.0908Z",
    fill: "url(#paint0_linear_246_6452)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.466 40.2686C17.8261 40.2686 14.0515 36.5639 14.0515 32.0099C14.0515 27.4557 17.8261 23.751 22.466 23.751C27.106 23.751 30.8808 27.4557 30.8808 32.0099C30.8808 36.5639 27.106 40.2686 22.466 40.2686Z",
    fill: "url(#paint1_linear_246_6452)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1995 35.2817L22.6041 34.1899L19.9989 35.2577L20.224 32.4247L18.4146 30.2498L21.1491 29.5906L22.6359 27.1787L24.1007 29.6044L26.8292 30.2887L25.0001 32.4468L25.1995 35.2817Z",
    fill: "#FFEFB9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1H17.0961L26.206 20.6342H19.5418L10 1Z",
    fill: "#7367F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_246_6452",
    x1: 20.3004,
    y1: 16.1531,
    x2: 8.05985,
    y2: 33.8986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_246_6452",
    x1: 21.6533,
    y1: 20.7011,
    x2: 11.8194,
    y2: 33.8527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD06D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99912"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalBadge);
export default __webpack_public_path__ + "static/media/medal-badge.407b8a21c9d70a70c0722fe81a252e73.svg";
export { ForwardRef as ReactComponent };